import _ from "lodash";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

type Props = {
    codenames: string[];
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
};

export const CodenameHeader = ({ codenames, columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["modals"]);
    const options = _.uniqBy(
        codenames.map((c) => ({ key: c, label: c })),
        "key",
    );
    const current = (columnFilters.find((f) => f.id === "codename")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.codename")}
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "codename");
                    return value.length ? [{ id: "codename", value }, ...rest] : rest;
                });
            }}
        />
    );
};
